<template>
<div id="body">
  <div class="timeline">
  <div class="tl left">
    <div class="content">
      <h2>2022</h2>
      <h3>Life Choices Coding Academy.</h3>
      <p>I started attending Life Choices Academy on 20th September 2021</p>
    </div>
  </div>
  <div class="tl right">
    <div class="content">
      <h2>2021</h2>
      <h3>Tsiba Business School</h3>
      <p>Early last year I was doing a Business Administration Degree at Tsiba Business, however I had to suspend my
          studies due to financial constraints </p>
    </div>
  </div>
  <div class="tl left">
    <div class="content">
      <h2>2016-2020</h2>
      <h3>Wynberg Boys High School</h3>
      <p>I matriculated in 2020 from Wynberg Boys High School</p>
    </div>
  </div>
  <div class="tl right">
    <div class="content">
      <h2>2008-2015</h2>
      <h3>Belthorn Primary School</h3>
      <p>I finished my primary school career at Belthorn Primary in 2015</p>
    </div>
  </div>
 
</div>
</div>
</template>

<script>
export default {

}
</script>

<style scoped>
* {
  box-sizing: border-box;
}

#body {
  background-color: #b0c4f1;
  font-family: Helvetica, sans-serif;
}

/* The actual timeline (the vertical ruler) */
.timeline {
  position: relative;
  max-width: 1200px;
  margin: 0 auto;
}

/* The actual timeline (the vertical ruler) */
.timeline::after {
  content: '';
  position: absolute;
  width: 6px;
  background-color: white;
  top: 0;
  bottom: 0;
  left: 50%;
  margin-left: -3px;
}

/* Container around content */
.tl {
  padding: 10px 40px;
  position: relative;
  background-color: inherit;
  width: 50%;
}

/* The circles on the timeline */
.tl::after {
  content: '';
  position: absolute;
  width: 25px;
  height: 25px;
  right: -17px;
  background-color: white;
  border: 4px solid #FF9F55;
  top: 15px;
  border-radius: 50%;
  z-index: 1;
}

/* Place the container to the left */
.left {
  left: 0;
}

/* Place the container to the right */
.right {
  left: 50%;
}

/* Add arrows to the left container (pointing right) */
.left::before {
  content: " ";
  height: 0;
  position: absolute;
  top: 22px;
  width: 0;
  z-index: 1;
  right: 30px;
  border: medium solid white;
  border-width: 10px 0 10px 10px;
  border-color: transparent transparent transparent white;
}

/* Add arrows to the right container (pointing left) */
.right::before {
  content: " ";
  height: 0;
  position: absolute;
  top: 22px;
  width: 0;
  z-index: 1;
  left: 30px;
  border: medium solid white;
  border-width: 10px 10px 10px 0;
  border-color: transparent white transparent transparent;
}

/* Fix the circle for containers on the right side */
.right::after {
  left: -16px;
}

/* The actual content */
.content {
  padding: 20px 30px;
  background-color: white;
  position: relative;
  border-radius: 6px;
}

/* Media queries - Responsive timeline on screens less than 600px wide */
@media screen and (max-width: 600px) {
  /* Place the timelime to the left */
  .timeline::after {
  left: 31px;
  }
  
  /* Full-width containers */
  .left::before {
  width: 100%;
  padding-left: 70px;
  padding-right: 25px;
  }
  
  /* Make sure that all arrows are pointing leftwards */
  .tl::before {
  left: 60px;
  border: medium solid white;
  border-width: 10px 10px 10px 0;
  border-color: transparent white transparent transparent;
  }

  /* Make sure all circles are at the same spot */
  .left::after, .right::after {
  left: 15px;
  }
  
  /* Make all right containers behave like the left ones */
  .right {
  left: 0%;
  }
}
</style>